var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-title"},[_c('div',{staticClass:"text"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_c('div',{staticStyle:{"flex":"1","display":"flex","justify-content":"space-between"}},[_c('div',{staticClass:"left"},[_vm._t("left")],2),_c('div',{staticClass:"right"},[_vm._t("right")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }